import { ILichSuYteRequest } from '../models/request/hoc-sinh/ILichSuYteRequest';
import { IReadUploadedExcelFileRequest } from '../models/request/upload-file/IReadUploadedExcelFileRequest';
import { apiGuestClient } from './apiGuestClient';

export const API_END_POINT = "lich-su-xuong-phong-y-te";

export const lichSuXuongPhongYTeApi = {
    selectByHocSinh: (ts_hocsinh_id: number) => apiGuestClient.get(`hoc-sinh/${ts_hocsinh_id}/lich-su-xuong-phong-y-te`),
    selectAll: (dm_cocso_id: number, nam_hoc: string, dm_truong_id?: number, tu_ngay?: string, den_ngay?: string) => {
        let url = dm_truong_id 
            ? `${API_END_POINT}/co-so/${dm_cocso_id}/nam-hoc/${nam_hoc}/truong/${dm_truong_id}`
            : `${API_END_POINT}/co-so/${dm_cocso_id}/nam-hoc/${nam_hoc}`;
        
        // Thêm query parameters cho tu_ngay và den_ngay
        const params = new URLSearchParams();
        if (tu_ngay) params.append('tu_ngay', tu_ngay);
        if (den_ngay) params.append('den_ngay', den_ngay);
        
        const queryString = params.toString();
        if (queryString) {
            url += `?${queryString}`;
        }
        
        return apiGuestClient.get(url);
    },
    selectById: (id: number) => apiGuestClient.get(`${API_END_POINT}/${id}`),
    insert: (request: ILichSuYteRequest) => apiGuestClient.post(`${API_END_POINT}`, request),
    update: (request: ILichSuYteRequest) => apiGuestClient.put(`${API_END_POINT}/${request.id}`, request),
    delete: (id: number) => apiGuestClient.delete(`${API_END_POINT}/${id}`),

    // Import functions
    validateImport: (data: IReadUploadedExcelFileRequest, nam_hoc: string, dm_coso_id: number) =>
        apiGuestClient.put(`${API_END_POINT}/validate-import/nam-hoc/${nam_hoc}/co-so/${dm_coso_id}`, data),

    import: (data: IReadUploadedExcelFileRequest, nam_hoc: string, dm_coso_id: number) =>
        apiGuestClient.put(`${API_END_POINT}/import/nam-hoc/${nam_hoc}/co-so/${dm_coso_id}`, data),

    // Export function
    exportData: (request: { nam_hoc: string, dm_coso_id: number }) =>
        apiGuestClient.get(`${API_END_POINT}/export/nam-hoc/${request.nam_hoc}/co-so/${request.dm_coso_id}`),

    // Export to template function
    exportToTemplate: (request: {
        nam_hoc: string,
        dm_coso_id: number,
        dm_truong_id?: number,
        tu_ngay?: string,
        den_ngay?: string,
        nhom_noi_dung?: number
    }) => {
        const params = new URLSearchParams();
        if (request.dm_truong_id && request.dm_truong_id > 0) params.append('dm_truong_id', request.dm_truong_id.toString());
        if (request.tu_ngay) params.append('tu_ngay', request.tu_ngay);
        if (request.den_ngay) params.append('den_ngay', request.den_ngay);
        if (request.nhom_noi_dung && request.nhom_noi_dung > 0) params.append('nhom_noi_dung', request.nhom_noi_dung.toString());

        const queryString = params.toString();
        const url = `${API_END_POINT}/export-template/nam-hoc/${request.nam_hoc}/co-so/${request.dm_coso_id}${queryString ? `?${queryString}` : ''}`;

        return apiGuestClient.get(url);
    }
};
